<template>
  <div>
    <b-form-input :value="value" @input="$emit('input', $event)" placeholder="Your Heading Here"></b-form-input>
  </div>
</template>

<script>
export default {
  name: 'CourseBuilderHeader',
  props: ['value']
};
</script>

<style scoped>

</style>